module.exports = __webpack_public_path__ + "./fonts/NachlieliCLM-Light.ttf";